import { configureEcho } from '@laravel/echo-react';

export interface AppWebSocketConfig {
  broadcaster: 'reverb' | 'pusher' | 'socket.io' | 'null';
  key: string;
  host?: string;
  wsPort?: number;
  wssPort?: number;
  forceTls?: boolean;
  authEndpoint?: string;
  downloadPath?: string;
  enabledTransports?: Array<'ws' | 'wss'>;
}

let lastConfiguredSignature = '';

export const configureAppEcho = (config: AppWebSocketConfig, token?: string | null) => {
  const nextSignature = JSON.stringify({
    ...config,
    token: token ?? '',
  });

  if (nextSignature === lastConfiguredSignature) {
    return;
  }

  configureEcho({
    broadcaster: config.broadcaster,
    key: config.key,
    wsHost: config.host,
    wsPort: config.wsPort,
    wssPort: config.wssPort,
    forceTLS: config.forceTls,
    enabledTransports: config.enabledTransports ?? ['ws', 'wss'],
    channelAuthorization: {
      endpoint: config.authEndpoint,
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : {},
    },
  });

  lastConfiguredSignature = nextSignature;
};

